import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var History = createReactComponent("History", ["svg", defaultAttributes, [["path", {
  d: "M3 3v5h5",
  key: "wxw82a"
}], ["path", {
  d: "M3.05 13A9 9 0 106 5.3L3 8",
  key: "y0tb33"
}], ["path", {
  d: "M12 7v5l4 2",
  key: "7lmkcx"
}]]]);
export default History;